import { Box, Grid, Divider, Stack, Paper } from '@mui/material';
import { useStoreState } from 'easy-peasy';
import { calculateSizeOfGamut } from "./../../utils/graph-helper";

export default function AchievableColorResult(props) {
  let { achieveColorCount, totalColorCount, otherDetails, fileName, virginResinDetails } =
    props.achievableColorData;

    otherDetails = otherDetails.slice(0, 55);
    virginResinDetails = virginResinDetails.slice(0, 55);

  let inputColor = useStoreState((state) => state.inputColor);
  let evaluationResult = useStoreState((state) => state.evaluationResult);

  const boxStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Optional: Center vertically
    minHeight: '35px',
    color: '#000000', fontSize: '14px', fontWeight: '400'
  };

  const multiLabelBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Optional: Center vertically
    minHeight: '35px',
    color: '#858585', fontSize: '15px', fontWeight: '400'
  };

  return (
    <Box sx={{ mb: '35px', width: '100%' }}>
      <Stack
        direction="column"
        spacing={1}
        sx={{
          alignItems: 'center',
          padding: '16px 16px 24px',
          alignItems: 'flex-start',
          borderRadius: '4px',
          border: '1px solid  #F0F0F0',
          background: 'rgba(0, 0, 0, 0.04)',
          fontFamily: 'Source Sans Pro',
          borderTop: '8px solid #385DAE',
        }}
      >

        <Grid container xs={12} spacing={0}>
            <Grid xs={4}  > 
              <Box
                sx={{
                  color: '#303C43',
                  fontSize: '22px',
                  fontWeight: '600',
                  lineHeight: '32px',
                }}
              >
                Achievable Color 
              </Box>
              
              <Box
                sx={{
                  fontFamily: 'Ubuntu',
                  color: '#385DAE',
                  fontSize: '26px',
                  fontWeight: '600',
                  lineHeight: '35px',
                }}
              >
                {achieveColorCount} / {totalColorCount}
              </Box>
            </Grid>
            <Grid item xs={0.3}>
              <Box
                sx={{
                  borderLeft: '1px solid #C7C9C7', // Creates the vertical line
                  height: '100%', // Full height of the container or parent Grid
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              
              />
            </Grid>
            <Grid container spacing={2} xs={7.7}>
              <Grid item xs={12} sm={2}>
              <Box sx={multiLabelBoxStyle}> rResin:</Box>
              <Box sx={multiLabelBoxStyle}> vResin:</Box>
              <Box sx={multiLabelBoxStyle}> File: </Box>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Box sx={boxStyle}> { otherDetails } | GamutVOL:  { calculateSizeOfGamut(evaluationResult['gamut']['recycleResinGamut']) }</Box>
                <Box sx={boxStyle}> { virginResinDetails } | GamutVOL:  { calculateSizeOfGamut(evaluationResult['gamut']['virginResinGamut'])}</Box>
                <Box sx={boxStyle}> { inputColor.fileName }</Box>
              </Grid>
            </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}
